import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { localeStrings as strings } from 'applicationConfig';
import ReportingDownloadGridRow from './ReportingDownloadGridRow';
import DownloadHelper from '../../utils/DownloadHelper';

@inject('settingsStore')
class ReportingDownloadGrid extends Component {
  handleClick = (path) => {
    const { downloadError, email } = strings.executionReportingDownload;
    const { error } = strings.generic;
    const message = () => (<h3>{downloadError} <a href={'mailto:' + email} className="mailto">{email}</a></h3>);
    DownloadHelper
      .downloadFile(path)
      .catch(() => {
        this.props.settingsStore.setAlertData({
          title: error,
          ChildElement: message
        });
      });
  };

  render() {
    const { data, type } = this.props;
    return (
      <div className="execution-reporting-grid">
        {data.map(item => <ReportingDownloadGridRow key={item.id} data={item} type={type} onClick={this.handleClick} />)}
      </div>
    );
  }
}

export default ReportingDownloadGrid;



// WEBPACK FOOTER //
// ./src/containers/ReportingDownload/ReportingDownloadGrid.jsx